import { FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { EAN_LENGTH, MAX_EMAIL_LENGTH } from "../../../../constants/inputValidationDefaults"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { BillReceiverType } from "../../../../modules/company/admin/organization/userGroups/userGroupsTypes"

import type { SendInvoiceCompany } from "../billReceiverTypes"

const useStyles = makeStyles()(() => ({
    dialogSubtitle: {
        marginBottom: "1rem",
    },
    input: {
        width: "10rem",
    },
}))

type SendInvoiceCompanySectionProps = Readonly<{
    value: SendInvoiceCompany
    onChange: (value: SendInvoiceCompany) => void
    validationError?: string
}>

export function SendInvoiceCompanySection({ value, onChange, validationError }: SendInvoiceCompanySectionProps) {
    const { classes } = useStyles()
    const { invoiceType, search } = value

    const label = invoiceType === BillReceiverType.EMAIL_ADDRESS ? "Email" : "EAN Number"
    const localizedKey =
        invoiceType === BillReceiverType.EMAIL_ADDRESS
            ? "bill-receivers-input-search-label-email"
            : "bill-receivers-input-search-label-ean-number"
    const type = invoiceType === BillReceiverType.EMAIL_ADDRESS ? "email" : "text"
    const maxLength = invoiceType === BillReceiverType.EMAIL_ADDRESS ? MAX_EMAIL_LENGTH : EAN_LENGTH

    const pushChange = (patch: Partial<SendInvoiceCompany>) => onChange({ ...value, ...patch })

    return (
        <Grid container direction="column" wrap="nowrap">
            <LocalizedStrict id="bill-receivers-send-invoice">
                <Typography className={classes.dialogSubtitle} variant="subtitle1" textAlign="start">
                    Send invoice to:
                </Typography>
            </LocalizedStrict>
            <Stack direction="row" spacing="1rem">
                <FormControl className={classes.input}>
                    <LocalizedStrict id="bill-receivers-select-label-input-type">
                        <InputLabel id="type-select-label">Type</InputLabel>
                    </LocalizedStrict>
                    <LocalizedStrict id="bill-receivers-dropdown-type" attrs={{ label: true }}>
                        <Select
                            labelId="type-select-label"
                            id="type-select"
                            value={invoiceType}
                            label="Type"
                            onChange={(e) => {
                                const nextType = e.target.value as BillReceiverType
                                pushChange({ invoiceType: nextType })
                            }}
                        >
                            <MenuItem value={BillReceiverType.EMAIL_ADDRESS}>
                                <LocalizedStrict id="bill-receivers-select-item-email">
                                    <span>Email</span>
                                </LocalizedStrict>
                            </MenuItem>
                            <MenuItem value={BillReceiverType.EAN_NUMBER}>
                                <LocalizedStrict id="bill-receivers-select-item-ean-number">
                                    <span>EAN Number</span>
                                </LocalizedStrict>
                            </MenuItem>
                        </Select>
                    </LocalizedStrict>
                </FormControl>
                <LocalizedStrict id={localizedKey} attrs={{ label: true }}>
                    <TextField
                        name="search"
                        value={search}
                        type={type}
                        label={label}
                        onChange={(e) => {
                            pushChange({ search: e.target.value })
                        }}
                        error={Boolean(validationError)}
                        helperText={validationError}
                        inputProps={{
                            maxLength,
                        }}
                    />
                </LocalizedStrict>
            </Stack>
        </Grid>
    )
}

